<template>
    <section class="col s12">
        <div class="row">
            <div class="col s12">
                <p>
                    Você repetiu o mesmo plano de trabalho para mais de um bolsista?
                </p>

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="repetiu_pdt"
                               class="with-gap"
                               type="radio"
                               id="rdSimRepetiuPdt"
                               :disabled="allDisabled"
                               :value="true"
                               v-model="repetiuPdtBolsista" />
                        <span>Sim</span>
                    </label>
                </div>
                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="repetiu_pdt"
                               :disabled="allDisabled"
                               class="with-gap"
                               type="radio"
                               id="rdNaoRepetiuPdt"
                               :value="false"
                               v-model="repetiuPdtBolsista" />
                        <span>Não</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="row" v-if="repetiuPdtBolsista">
            <div class="col s12">
                <strong>Justificativa</strong>

                <textarea style="width: 100%; min-height: 150px;"
                          name="repetiuPdtBolsistaJustificativa"
                          id="repetiuPdtBolsistaJustificativa"
                          :disabled="allDisabled"
                          :maxlength="maximoDeCaracteresParaJustificativaPdtRepetido"
                          v-model="repetiuPdtBolsistaJustificativa"
                          cols="30" rows="10"
                          class="browser-default"></textarea>

                <span class="right" style="font-size: small;">{{ !repetiuPdtBolsistaJustificativa ? 0 : repetiuPdtBolsistaJustificativa.length }}/{{ maximoDeCaracteresParaJustificativaPdtRepetido }}</span>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "pdt_repetiu_justificativa",
    props: {
        pRepetiuPdtBolsista: {
            type: Boolean,
            default: false,
        },
        pRepetiuPdtBolsistaJustificativa: {
            type: String,
            default: null,
        },
        allDisabled: {
            type: Boolean,
            default: false,
        },
        maximoDeCaracteresParaJustificativaPdtRepetido: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            repetiuPdtBolsista: this.pRepetiuPdtBolsista,
            repetiuPdtBolsistaJustificativa: this.pRepetiuPdtBolsistaJustificativa
        }
    },
    watch: {
        pRepetiuPdtBolsista(newValue) {
            this.repetiuPdtBolsista = newValue
        },
        repetiuPdtBolsista(newValue) {
            if(!newValue)
                this.repetiuPdtBolsistaJustificativa = null

            this.$emit('update:pRepetiuPdtBolsista', newValue)
        },
        pRepetiuPdtBolsistaJustificativa(newValue) {
            this.repetiuPdtBolsistaJustificativa = newValue
        },
        repetiuPdtBolsistaJustificativa(newValue) {
            this.$emit('update:pRepetiuPdtBolsistaJustificativa', newValue)
        },
    },
}
</script>

<style scoped>

</style>
